import { useCallback, useState } from 'react';
import styles from './search-section.module.sass';
import TextInput from 'componets/text-input';
import Button from 'componets/button';
import icon from 'images/icons/search.svg';

export const SearchSection = ({ defaultSearchQuery, onSubmit, placeholder }) => {
  const [searchQuery, setSearchQuery] = useState(defaultSearchQuery ?? '');

  const handleSearchQueryChange = useCallback(q => {
    setSearchQuery(q);
  }, []);

  const handleClear = useCallback(() => {
    setSearchQuery('');
  }, []);

  return (
    <form className={styles['search-section']} onSubmit={e => e.preventDefault()}>
      <TextInput
        icon={icon}
        placeholder={placeholder}
        onTextChange={handleSearchQueryChange}
        newText={searchQuery}
        onClear={handleClear}
        maxLength={10}
      />
      <Button type="submit" variant="search" onClick={() => onSubmit(searchQuery)}>
        搜尋
      </Button>
    </form>
  );
};
